import React, { ReactNode, useEffect, useState } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Button, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UserInfos from '../../components/UserInfo/UserInfos';
import AccordionCustom from '../../components/AccordionCustom/AccordionCustom';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { useUserContext } from '../../hooks/auth/UserProvider';
import { useNavigate } from 'react-router-dom';
import { checkIfUserIsCompanyOrAssociation, checkUserEnabled } from '../../helpers/authorizedUser';
import ChangePassword from '../../components/ChangePassword/ChangePassword';
import MarketList from '../../components/Markets/MarketList';
import { GREEN_MAIN } from '../../theme/colors';

interface DefaultAssocAndCompanyPageProps{
    titleType?: number;
    children: ReactNode;
}

const DefaultCompanyAndAssociationPage: React.FC<DefaultAssocAndCompanyPageProps> = ({children, titleType}) => {
  const {t} = useTranslationContext();

  // utente autorizzato
  const {user, auth} = useUserContext();
  const navigate = useNavigate();
  const {checkIsAuth} = useUserContext();
  const [title, setTitle] = useState<string>("");
  const [subtitle, setSubTitle] = useState<string|null>(null);

  useEffect(() => {
    if (auth.isLoading) return;

    // Se non autenticato → login con redirect alla pagina corrente
    if (!auth.isAuthenticated) {
        auth.signinRedirect({ state: window.location.pathname });
        return;
    }

    // Se utente presente
    if (auth.user && user) {
        // Se utente non abilitato → torna alla home
        if (!checkUserEnabled(user)) {
            navigate('/');
            return;
        }

        // Se utente non è Company o Association → torna alla home
        if (!checkIfUserIsCompanyOrAssociation(user)) {
            navigate('/');
            return;
        }
    }

    // Esegui comunque il controllo auth (non blocca)
    checkIsAuth().finally();

}, [auth.isLoading, auth.isAuthenticated, auth.user, user, navigate]);

  useEffect(()=>{
    if(titleType !== null && titleType !== undefined){
      switch(titleType){
        case 0:
          setTitle("Preleva ASSO dal portafogli elettronico e depositali sul tuo conto");
          setSubTitle(null);
          break;
        case 1:
          setTitle("Riscatta ASSO");
          setSubTitle("(convertili in euro)");
          break;
        case 2:
          setTitle("Vendi nel circuito");
          setSubTitle(null);
          break;
        default:
          setTitle("");
          setSubTitle(null);
          break;
      }
    }else{
      setTitle("");
      setSubTitle(null);
    }
  },[children])

  return (
    <>
      <Box sx={{
        width:'100%', 
        display:'flex', 
        flexDirection:'column',
        color: GREEN_MAIN,
        fontFamily:'poppins'
      }}>
        {
        auth.isAuthenticated && 
        <>
            {/* Main title */}
            <Grid container justifyContent='center'>
              <Grid item xs={12} sm={9} md={6}>
                <Typography
                    variant="h3"
                    component="h1"
                    gutterBottom
                    sx={{
                        mb: 0,
                        mt: 0,
                        fontWeight: "bold",
                    }}
                >
                    {t(title)}
                </Typography>
                {subtitle && <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        mb: 0,
                        mt: 0,
                    }}
                >
                    {t(subtitle)}
                </Typography>}
              </Grid>
            </Grid>
            {children}
          </>
        }
        
      </Box>
    </>
  );
};

export default DefaultCompanyAndAssociationPage;
